<template>
  <a-modal
    v-model="visible"
    title="提示"
    okText="下一步"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div v-if="type == 1" class="info">
      <div>信息保存成功</div>
      <!-- <div>请点击【下一步】继续表单下载</div> -->
      <div>请点击【下一步】继续</div>
    </div>
    <div v-if="type == 2" class="info">
      <div>表单下载成功</div>
      <!-- <div>请点击【下一步】继续证明材料上传</div> -->
      <div>请点击【下一步】继续</div>
    </div>
    <div v-if="type == 3" class="info">
      <div>证明材料上传成功</div>
      <!-- <div>如需进行获奖资料上传，请点击【下一步】继续获奖资料上传</div> -->
      <div>请点击【下一步】继续</div>
    </div>
    <div v-if="type == 4" class="info">
      <div>信息保存成功</div>
      <!-- <div>请点击【下一步】继续表单下载</div> -->
      <div>请点击【下一步】继续</div>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: 0,
    };
  },
  methods: {
    show(type) {
      this.visible = true;
      console.log(type);
      this.type = type;
    },
    handleOk() {
      this.$emit("next", this.type);
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  text-align: center;
  div {
    margin: 20px 0;
  }
}
</style>
